<body>
  <div class="container" style="padding-left:0px;padding-right:0px">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</body>




